import moment from 'moment'
import cx from 'classnames'

import Styles from './Date.module.scss'

import { Condition } from '../../../../../../Filter'
import { Operator } from '../../../../../../constants'
import { DatePicker } from 'common/DatePicker/DatePicker'

interface Props {
  condition: Condition
  onChange: (value: any) => void
  isDisabled?: boolean
}

export const Date = ({ condition, onChange, isDisabled = false }: Props) => {
  const updateStart = (value: any) => {
    if (condition.value[1] && moment(value).isBefore(moment(condition.value[1]))) {
      onChange([value, condition.value[1]])
      return
    }

    onChange([value, moment(value).add(1, 'days').format('YYYY-MM-DD')])
  }

  const updateEnd = (value: any) => {
    if (condition.value[0] && moment(value).isAfter(moment(condition.value[0]))) {
      onChange([condition.value[0], value])
      return
    }

    onChange([moment(value).subtract(1, 'days').format('YYYY-MM-DD'), value])
  }

  return (
    <div>
      {condition.operator === Operator.Between ? (
        <div className={cx(Styles.betweenContainer, { [Styles.uneditable]: isDisabled })}>
          <DatePicker
            value={condition.value[0] || ''}
            onChange={updateStart}
            readOnly={isDisabled}
            variant="filter"
            size="md"
          />
          <span className={cx(Styles.emDash, { [Styles.uneditable]: isDisabled })}>—</span>
          <DatePicker
            value={condition.value[1] || ''}
            onChange={updateEnd}
            readOnly={isDisabled}
            variant="filter"
            size="md"
          />
        </div>
      ) : (
        <DatePicker
          value={condition.value[0] || ''}
          onChange={(value) => onChange([value])}
          readOnly={isDisabled}
          variant="filter"
          size="md"
        />
      )}
    </div>
  )
}
